// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_89aab0bd",
      load: () => import("#nuxt-i18n/89aab0bd" /* webpackChunkName: "locale_en_46json_89aab0bd" */),
      cache: true
    },
    {
      key: "locale_en_46json_f6575586",
      load: () => import("#nuxt-i18n/f6575586" /* webpackChunkName: "locale_en_46json_f6575586" */),
      cache: true
    },
    {
      key: "locale_en_46json_83c02900",
      load: () => import("#nuxt-i18n/83c02900" /* webpackChunkName: "locale_en_46json_83c02900" */),
      cache: true
    },
    {
      key: "locale_en_46json_496c238d",
      load: () => import("#nuxt-i18n/496c238d" /* webpackChunkName: "locale_en_46json_496c238d" */),
      cache: true
    },
    {
      key: "locale_en_46json_062c1aa3",
      load: () => import("#nuxt-i18n/062c1aa3" /* webpackChunkName: "locale_en_46json_062c1aa3" */),
      cache: true
    },
    {
      key: "locale_en_46json_9fd2e190",
      load: () => import("#nuxt-i18n/9fd2e190" /* webpackChunkName: "locale_en_46json_9fd2e190" */),
      cache: true
    },
    {
      key: "locale_en_46json_6ea82956",
      load: () => import("#nuxt-i18n/6ea82956" /* webpackChunkName: "locale_en_46json_6ea82956" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_ea42e08a",
      load: () => import("#nuxt-i18n/ea42e08a" /* webpackChunkName: "locale_fr_46json_ea42e08a" */),
      cache: true
    },
    {
      key: "locale_fr_46json_2ac27321",
      load: () => import("#nuxt-i18n/2ac27321" /* webpackChunkName: "locale_fr_46json_2ac27321" */),
      cache: true
    },
    {
      key: "locale_fr_46json_cb2fad1a",
      load: () => import("#nuxt-i18n/cb2fad1a" /* webpackChunkName: "locale_fr_46json_cb2fad1a" */),
      cache: true
    },
    {
      key: "locale_fr_46json_218f09d2",
      load: () => import("#nuxt-i18n/218f09d2" /* webpackChunkName: "locale_fr_46json_218f09d2" */),
      cache: true
    },
    {
      key: "locale_fr_46json_390dd6b4",
      load: () => import("#nuxt-i18n/390dd6b4" /* webpackChunkName: "locale_fr_46json_390dd6b4" */),
      cache: true
    },
    {
      key: "locale_fr_46json_c69693ec",
      load: () => import("#nuxt-i18n/c69693ec" /* webpackChunkName: "locale_fr_46json_c69693ec" */),
      cache: true
    },
    {
      key: "locale_fr_46json_0dfb009d",
      load: () => import("#nuxt-i18n/0dfb009d" /* webpackChunkName: "locale_fr_46json_0dfb009d" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_a78b77ed",
      load: () => import("#nuxt-i18n/a78b77ed" /* webpackChunkName: "locale_nl_46json_a78b77ed" */),
      cache: true
    },
    {
      key: "locale_nl_46json_71eff815",
      load: () => import("#nuxt-i18n/71eff815" /* webpackChunkName: "locale_nl_46json_71eff815" */),
      cache: true
    },
    {
      key: "locale_nl_46json_7376e7c4",
      load: () => import("#nuxt-i18n/7376e7c4" /* webpackChunkName: "locale_nl_46json_7376e7c4" */),
      cache: true
    },
    {
      key: "locale_nl_46json_cd99fb4a",
      load: () => import("#nuxt-i18n/cd99fb4a" /* webpackChunkName: "locale_nl_46json_cd99fb4a" */),
      cache: true
    },
    {
      key: "locale_nl_46json_57fdb00f",
      load: () => import("#nuxt-i18n/57fdb00f" /* webpackChunkName: "locale_nl_46json_57fdb00f" */),
      cache: true
    },
    {
      key: "locale_nl_46json_b01b86ae",
      load: () => import("#nuxt-i18n/b01b86ae" /* webpackChunkName: "locale_nl_46json_b01b86ae" */),
      cache: true
    },
    {
      key: "locale_nl_46json_8fd3fe05",
      load: () => import("#nuxt-i18n/8fd3fe05" /* webpackChunkName: "locale_nl_46json_8fd3fe05" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_0d7ba23c",
      load: () => import("#nuxt-i18n/0d7ba23c" /* webpackChunkName: "locale_de_46json_0d7ba23c" */),
      cache: true
    },
    {
      key: "locale_de_46json_34c974ad",
      load: () => import("#nuxt-i18n/34c974ad" /* webpackChunkName: "locale_de_46json_34c974ad" */),
      cache: true
    },
    {
      key: "locale_de_46json_ffa7b487",
      load: () => import("#nuxt-i18n/ffa7b487" /* webpackChunkName: "locale_de_46json_ffa7b487" */),
      cache: true
    },
    {
      key: "locale_de_46json_106483b8",
      load: () => import("#nuxt-i18n/106483b8" /* webpackChunkName: "locale_de_46json_106483b8" */),
      cache: true
    },
    {
      key: "locale_de_46json_29ab8f4a",
      load: () => import("#nuxt-i18n/29ab8f4a" /* webpackChunkName: "locale_de_46json_29ab8f4a" */),
      cache: true
    },
    {
      key: "locale_de_46json_ebda003c",
      load: () => import("#nuxt-i18n/ebda003c" /* webpackChunkName: "locale_de_46json_ebda003c" */),
      cache: true
    },
    {
      key: "locale_de_46json_f7031e01",
      load: () => import("#nuxt-i18n/f7031e01" /* webpackChunkName: "locale_de_46json_f7031e01" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_009c7eed",
      load: () => import("#nuxt-i18n/009c7eed" /* webpackChunkName: "locale_es_46json_009c7eed" */),
      cache: true
    },
    {
      key: "locale_es_46json_f7b9edf7",
      load: () => import("#nuxt-i18n/f7b9edf7" /* webpackChunkName: "locale_es_46json_f7b9edf7" */),
      cache: true
    },
    {
      key: "locale_es_46json_7cf01c94",
      load: () => import("#nuxt-i18n/7cf01c94" /* webpackChunkName: "locale_es_46json_7cf01c94" */),
      cache: true
    },
    {
      key: "locale_es_46json_886a63ba",
      load: () => import("#nuxt-i18n/886a63ba" /* webpackChunkName: "locale_es_46json_886a63ba" */),
      cache: true
    },
    {
      key: "locale_es_46json_80959034",
      load: () => import("#nuxt-i18n/80959034" /* webpackChunkName: "locale_es_46json_80959034" */),
      cache: true
    },
    {
      key: "locale_es_46json_3922021c",
      load: () => import("#nuxt-i18n/3922021c" /* webpackChunkName: "locale_es_46json_3922021c" */),
      cache: true
    },
    {
      key: "locale_es_46json_943549be",
      load: () => import("#nuxt-i18n/943549be" /* webpackChunkName: "locale_es_46json_943549be" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_8eb6762e",
      load: () => import("#nuxt-i18n/8eb6762e" /* webpackChunkName: "locale_it_46json_8eb6762e" */),
      cache: true
    },
    {
      key: "locale_it_46json_3d5f96d5",
      load: () => import("#nuxt-i18n/3d5f96d5" /* webpackChunkName: "locale_it_46json_3d5f96d5" */),
      cache: true
    },
    {
      key: "locale_it_46json_1aedfdaa",
      load: () => import("#nuxt-i18n/1aedfdaa" /* webpackChunkName: "locale_it_46json_1aedfdaa" */),
      cache: true
    },
    {
      key: "locale_it_46json_8b0f0bb0",
      load: () => import("#nuxt-i18n/8b0f0bb0" /* webpackChunkName: "locale_it_46json_8b0f0bb0" */),
      cache: true
    },
    {
      key: "locale_it_46json_edce5eb7",
      load: () => import("#nuxt-i18n/edce5eb7" /* webpackChunkName: "locale_it_46json_edce5eb7" */),
      cache: true
    },
    {
      key: "locale_it_46json_e2c026ee",
      load: () => import("#nuxt-i18n/e2c026ee" /* webpackChunkName: "locale_it_46json_e2c026ee" */),
      cache: true
    },
    {
      key: "locale_it_46json_2dc0030b",
      load: () => import("#nuxt-i18n/2dc0030b" /* webpackChunkName: "locale_it_46json_2dc0030b" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_f9b6c764",
      load: () => import("#nuxt-i18n/f9b6c764" /* webpackChunkName: "locale_pl_46json_f9b6c764" */),
      cache: true
    },
    {
      key: "locale_pl_46json_e0c67341",
      load: () => import("#nuxt-i18n/e0c67341" /* webpackChunkName: "locale_pl_46json_e0c67341" */),
      cache: true
    },
    {
      key: "locale_pl_46json_b10ac5c1",
      load: () => import("#nuxt-i18n/b10ac5c1" /* webpackChunkName: "locale_pl_46json_b10ac5c1" */),
      cache: true
    },
    {
      key: "locale_pl_46json_ce229309",
      load: () => import("#nuxt-i18n/ce229309" /* webpackChunkName: "locale_pl_46json_ce229309" */),
      cache: true
    },
    {
      key: "locale_pl_46json_c05727fb",
      load: () => import("#nuxt-i18n/c05727fb" /* webpackChunkName: "locale_pl_46json_c05727fb" */),
      cache: true
    },
    {
      key: "locale_pl_46json_8702338a",
      load: () => import("#nuxt-i18n/8702338a" /* webpackChunkName: "locale_pl_46json_8702338a" */),
      cache: true
    },
    {
      key: "locale_pl_46json_f31c0063",
      load: () => import("#nuxt-i18n/f31c0063" /* webpackChunkName: "locale_pl_46json_f31c0063" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_b5f1b9a1",
      load: () => import("#nuxt-i18n/b5f1b9a1" /* webpackChunkName: "locale_ko_46json_b5f1b9a1" */),
      cache: true
    },
    {
      key: "locale_ko_46json_78e10660",
      load: () => import("#nuxt-i18n/78e10660" /* webpackChunkName: "locale_ko_46json_78e10660" */),
      cache: true
    },
    {
      key: "locale_ko_46json_add1b8e9",
      load: () => import("#nuxt-i18n/add1b8e9" /* webpackChunkName: "locale_ko_46json_add1b8e9" */),
      cache: true
    },
    {
      key: "locale_ko_46json_64afb329",
      load: () => import("#nuxt-i18n/64afb329" /* webpackChunkName: "locale_ko_46json_64afb329" */),
      cache: true
    },
    {
      key: "locale_ko_46json_3cb72480",
      load: () => import("#nuxt-i18n/3cb72480" /* webpackChunkName: "locale_ko_46json_3cb72480" */),
      cache: true
    },
    {
      key: "locale_ko_46json_5352da6f",
      load: () => import("#nuxt-i18n/5352da6f" /* webpackChunkName: "locale_ko_46json_5352da6f" */),
      cache: true
    },
    {
      key: "locale_ko_46json_05439c3b",
      load: () => import("#nuxt-i18n/05439c3b" /* webpackChunkName: "locale_ko_46json_05439c3b" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_b49c5eaa",
      load: () => import("#nuxt-i18n/b49c5eaa" /* webpackChunkName: "locale_uk_46json_b49c5eaa" */),
      cache: true
    },
    {
      key: "locale_uk_46json_52d8d4d6",
      load: () => import("#nuxt-i18n/52d8d4d6" /* webpackChunkName: "locale_uk_46json_52d8d4d6" */),
      cache: true
    },
    {
      key: "locale_uk_46json_f58175cc",
      load: () => import("#nuxt-i18n/f58175cc" /* webpackChunkName: "locale_uk_46json_f58175cc" */),
      cache: true
    },
    {
      key: "locale_uk_46json_20b12232",
      load: () => import("#nuxt-i18n/20b12232" /* webpackChunkName: "locale_uk_46json_20b12232" */),
      cache: true
    },
    {
      key: "locale_uk_46json_22a2ef2c",
      load: () => import("#nuxt-i18n/22a2ef2c" /* webpackChunkName: "locale_uk_46json_22a2ef2c" */),
      cache: true
    },
    {
      key: "locale_uk_46json_51858c0b",
      load: () => import("#nuxt-i18n/51858c0b" /* webpackChunkName: "locale_uk_46json_51858c0b" */),
      cache: true
    },
    {
      key: "locale_uk_46json_ec4a8e47",
      load: () => import("#nuxt-i18n/ec4a8e47" /* webpackChunkName: "locale_uk_46json_ec4a8e47" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined
  }
]

